import React, { useState } from "react";
import styles from "./VendorPanel.module.css";

export default function VendorPanel({ vendors, loadingVendors, onChange }) {
  const [list, setList] = useState([
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 },
    { name: "", id: null, show: false, highlight: -1 } 
  ]);
  
  const handleChange = (idx, value) => {
    const newList = [...list];
    newList[idx].name = value;
    newList[idx].id = null;
    newList[idx].show = true;
    newList[idx].highlight = 0;
    setList(newList);
    onChange && onChange(newList);
  };

  const handleKeyDown = (idx, e) => {
    const filtered = vendors.filter(vv =>
      vv.name.toLowerCase().includes(list[idx].name.toLowerCase())
    );

    if (!list[idx].show || !filtered.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight < filtered.length - 1
          ? newList[idx].highlight + 1
          : 0;
      setList(newList);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newList = [...list];
      newList[idx].highlight =
        newList[idx].highlight > 0
          ? newList[idx].highlight - 1
          : filtered.length - 1;
      setList(newList);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (list[idx].highlight >= 0) {
        const vv = filtered[list[idx].highlight];
        selectVendor(idx, vv);
      }
    } else if (e.key === "Escape") {
      const newList = [...list];
      newList[idx].show = false;
      setList(newList);
    }
  };

  const selectVendor = (idx, vendor) => {
    const newList = [...list];
    newList[idx].name = vendor.name;
    newList[idx].id = vendor.id;
    newList[idx].show = false;
    setList(newList);
    onChange && onChange(newList);
  };

  return (
    <div className={styles.sidePane}>
      <div className={styles.scrollWrap}>
        <table className={styles.vendorTable}>
          <thead>
            <tr>
              <th>거래처 1</th>
              <th>거래처 2</th>
              <th>거래처 3</th>
              <th>거래처 4</th>
              <th>거래처 5</th> 

            </tr>
          </thead>
          <tbody>
            <tr className={styles.inputRow}>
              {list.map((v, idx) => {
                const filtered = vendors.filter(vv =>
                  vv.name.toLowerCase().includes(v.name.toLowerCase())
                );

                return (
                  <td key={idx} style={{ position: "relative", overflow: "visible" }}>

                    <input
                      value={v.name}
                      onChange={(e) => handleChange(idx, e.target.value)}
                      onFocus={() => {
                        const newList = [...list];
                        newList[idx].show = true;
                        setList(newList);
                      }}
                      onKeyDown={(e) => handleKeyDown(idx, e)}
                      placeholder={`거래처 ${idx + 1}`}
                    />
                    
                    {v.show && (
                      <div className={styles.vendorDropdown}>
                        {loadingVendors && <div>불러오는 중...</div>}
                        {filtered.length ? (
                          filtered.map((vv, i) => (
                            <div
                              key={vv.id}
                              className={`${styles.vendorItem} ${i === v.highlight ? styles.activeItem : ""}`}
                              onClick={() => selectVendor(idx, vv)}
                            >
                              {vv.name}
                            </div>
                          ))
                        ) : (
                          <div className={styles.vendorItem}>일치하는 거래처 없음</div>
                        )}
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}